import { solvePow as e } from "@akedly/shield";
//#region src/passkeys/web/shieldPow.ts
var t = async (t, n) => {
	let { nonce: r } = await e(t, n);
	return r;
};
//#endregion
export { t as solvePowWeb };
